// Mock data for Expert Plasterer website

export const businessInfo = {
  name: "Expert Plasterer",
  tagline: "Professional Plastering Done Right",
  phone: "07300 405045",
  whatsapp: "447300405045",
  email: "info@expert-plasterer.co.uk",
  coverage: "Greater Manchester",
  badges: [
    "12-Month Guarantee",
    "Price Promise",
    "No VAT"
  ]
};

export const services = [
  {
    id: 1,
    title: "Plastering & Re-plastering",
    description: "Complete plastering solutions for new builds and renovation projects. Smooth, professional finishes every time.",
    image: "https://customer-assets.emergentagent.com/job_skilled-plastering/artifacts/lrqm3c5v_Skimming.jpeg",
    slug: "plastering"
  },
  {
    id: 2,
    title: "Skimming",
    description: "Expert skim coating to create perfectly smooth walls. Ideal for refreshing tired or damaged plasterwork.",
    image: "https://customer-assets.emergentagent.com/job_skilled-plastering/artifacts/lrqm3c5v_Skimming.jpeg",
    slug: "skimming"
  },
  {
    id: 3,
    title: "Rendering",
    description: "Professional exterior rendering to protect and beautify your property. Weather-resistant finishes that last.",
    image: "https://customer-assets.emergentagent.com/job_skilled-plastering/artifacts/auumbydc_Rendering%20an%20outside%20wall.png",
    slug: "rendering"
  },
  {
    id: 4,
    title: "Patch Repairs",
    description: "Expert repair of damaged plaster, cracks, and holes. Seamless fixes that blend perfectly with existing walls.",
    image: "https://customer-assets.emergentagent.com/job_skilled-plastering/artifacts/tqxdx6oh_Patch%20Plastering.jpeg",
    slug: "patch-repairs"
  },
  {
    id: 5,
    title: "Plaster Boarding",
    description: "Professional plasterboard installation for new walls and ceilings. Solid foundations for a perfect finish.",
    image: "https://customer-assets.emergentagent.com/job_skilled-plastering/artifacts/jvtsgg8p_Boarding.jpeg",
    slug: "plaster-boarding"
  }
];

export const testimonials = [
  {
    id: 1,
    quote: "Fantastic plastering work throughout our living room. The finish is flawless - completely smooth and ready for painting. Very tidy worker too.",
    name: "Sarah M.",
    location: "Stockport",
    service: "Plastering"
  },
  {
    id: 2,
    quote: "Had the whole house skimmed after removing old wallpaper. Brilliant job, fair price, and finished ahead of schedule. Highly recommend.",
    name: "Dave T.",
    location: "Cheadle",
    service: "Skimming"
  },
  {
    id: 3,
    quote: "New render on our external walls. Looks amazing and the price was very competitive. Professional from start to finish.",
    name: "Karen B.",
    location: "Bramhall",
    service: "Rendering"
  },
  {
    id: 4,
    quote: "Quick response for a patch repair job. You can't even tell where the damage was. Great attention to detail.",
    name: "James K.",
    location: "Sale",
    service: "Patch Repairs"
  }
];

export const features = [
  {
    id: 1,
    title: "12-Month Guarantee",
    description: "All work guaranteed for 12 months. If there's a problem, I'll come back and sort it.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Fair Prices",
    description: "Competitive rates. I'll beat any like-for-like written quote by 10%.",
    icon: "BadgePoundSterling"
  },
  {
    id: 3,
    title: "No VAT",
    description: "The price I quote is the price you pay. No hidden extras.",
    icon: "Receipt"
  }
];

export const trustPlatforms = [
  "Checkatrade",
  "MyBuilder",
  "Rated People",
  "TaskRabbit"
];
